"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressError = void 0;
var AddressError = /** @class */ (function (_super) {
    __extends(AddressError, _super);
    function AddressError(message, parseMessage) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AddressError';
        if (parseMessage !== null) {
            _this.parseMessage = parseMessage;
        }
        return _this;
    }
    return AddressError;
}(Error));
exports.AddressError = AddressError;
//# sourceMappingURL=address-error.js.map